import React from 'react';
import { repeatIcon } from '@chordbaker/design';

interface RepeatIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const paths = repeatIcon.elements as { d: string }[];

const RepeatIcon: React.FC<RepeatIconProps> = ({
  size = repeatIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={repeatIcon.viewBox}
      fill={repeatIcon.fill}
      stroke={color}
      strokeWidth={repeatIcon.strokeWidth}
      strokeLinecap={repeatIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={repeatIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      className={className}
      aria-hidden="true"
    >
      {paths.map(path => (
        <path key={path.d} d={path.d} />
      ))}
    </svg>
  );
};

export default RepeatIcon;
